import React from 'react';

import P from '../p';

export default () => {

    return <P></P>
}